import { connect, ConnectedProps } from "react-redux"
import { actions } from "../../../redux/actions"
import { RootState } from "../../../redux/store"

const mapState = (state: RootState) => ({
  isFetching: state.editor.fetching,
  categories: state.editor.categories,
  selectedId: state.editor.selectedCategoryId,
  isOpen: state.editor.isCategoryModalOpen
})

const mapDispatch = (dispatch: any, props: { from?: string | null }) => ({
  onClose: () => {
    dispatch(actions.editor.closeCategoryModal())
  },
  onSelect: (id: string) => {
    dispatch(actions.editor.selectCategory({ id }))
  },
  onPublish: () => {
    dispatch(actions.editor.fetchSave({ from: props.from }))
  },
})

export const connector = connect(mapState, mapDispatch)
export type ContainerProps = ConnectedProps<typeof connector>
